import Api from "../../../shared/Api";
import { ICopywriter, ICopywriterLanguage } from "../Entities";


class CopywritersAPI {
    static getCopywriters(): Promise<ICopywriter[]> {
        return new Api().get('/views/copywriters');
    }

    static getCopywriter(id: number): Promise<ICopywriter> {
        return new Api().get(`/views/copywriters/${id}`);
    }

    static getAvailableLanguage(): Promise<ICopywriterLanguage[]> {
        return new Api().get('/views/copywriters/language');
    }

    static createCopywriter(copywriter: ICopywriter): Promise<ICopywriter> {
        return new Api().post('/views/copywriters', copywriter);
    }

    static updateCopywriter(copywriter: ICopywriter): Promise<ICopywriter> {
        return new Api().put('/views/copywriters', copywriter);
    }

    static deleteCopywriter(copywriterId: number): Promise<boolean> {
        return new Api().delete(`/views/copywriters/${copywriterId}`);
    }
}

export default CopywritersAPI;